import React from 'react';
import { Route } from 'react-router-dom';

import DadosAcessos from '../../Adm/DadosAcessos';
import DadosLogs from '../../Adm/DadosLogs';
import DadosRelatorios from '../../Adm/DadosRelatorios';
import FichaUsuario from '../../Adm/FichaUsuario';
import HistoricoRT from '../../Adm/HistoricoRT';
import HistoricoVinculacoes from '../../Adm/HistoricoVinculacoes';
import ListaUsuarios from '../../Adm/ListaUsuarios';

const AdmRoutes = () => {
  return (
    <>
      <Route path="adm/usuarios" element={<ListaUsuarios />} />

      <Route path="adm/acessos" element={<DadosAcessos />} />
      <Route path="adm/logs" element={<DadosLogs />} />
      <Route path="adm/relatorios" element={<DadosRelatorios />} />
      <Route path="adm/historicodert" element={<HistoricoRT />} />
      <Route
        path="adm/historicodevinculacoes"
        element={<HistoricoVinculacoes />}
      />

      {/* Dados do Usuário */}
      <Route
        path="adm/usuarios/ficha/:id/dadosgerais"
        element={<FichaUsuario />}
      />
    </>
  );
};

export default AdmRoutes;
